import AppLogo from '@/components/layout/app-logo';
import { Button } from '@/components/ui/button';
import { login } from '@/routes/admin';
import { Link } from '@inertiajs/react';

export function HomeHeader({ auth }: { auth: { user?: unknown } }) {
    return (
        <header className="mx-auto flex w-full max-w-6xl items-center justify-between px-6 py-6">
            <Link
                href="/"
                aria-label="Return to Staydeed home"
                className="group flex items-center"
            >
                <span className="flex items-center gap-2">
                    <AppLogo />
                </span>
            </Link>
            <nav className="flex items-center gap-4 text-sm font-medium">
                <Link
                    href="#highlights"
                    className="text-slate-600 transition hover:text-slate-900 dark:hover:text-white"
                >
                    Highlights
                </Link>
                <Link
                    href="#moments"
                    className="text-slate-600 transition hover:text-slate-900 dark:hover:text-white"
                >
                    Moments
                </Link>
                <Link
                    href="#stories"
                    className="text-slate-600 transition hover:text-slate-900 dark:hover:text-white"
                >
                    Stories
                </Link>
            </nav>
            <div className="flex items-center gap-3">
                {auth.user ? (
                    <Button
                        asChild
                        variant="outline"
                        className="border-slate-200 text-slate-700 dark:border-slate-700"
                    >
                        <Link href="/">Enter admin</Link>
                    </Button>
                ) : (
                    <>
                        <Button
                            asChild
                            variant="ghost"
                            className="text-slate-700 hover:text-slate-900 dark:hover:text-white"
                        >
                            <Link href={login()}>Sign in</Link>
                        </Button>
                        {/* <Button asChild>
                            <Link href={register()}>
                                Reserve your stay
                            </Link>
                        </Button> */}
                    </>
                )}
            </div>
        </header>
    );
}
